<div mat-dialog-title>
  <h2>Media Uploaded</h2>
</div>

<div mat-dialog-content class="media__images">
  @if (expandedMedia$()) {
    <div class="media__images-expanded">
      <button mat-icon-button matTooltip="Close Expanded Image" (click)="expandedMediaIndex$.set(null)">
        <fa-icon [icon]="faClose"></fa-icon>
      </button>
      @if (expandedMedia$().type === fileType.VideoMp4) {
        <video eiq-media-broken controls>
          <source [src]="expandedMedia$().url$ | async" />
        </video>
      } @else if (expandedMedia$().type === fileType.AudioMp3) {
        <audio controls>
          <source [src]="expandedMedia$().url$ | async" />
        </audio>
      } @else {
        <img eiq-media-broken [src]="expandedMedia$().url$ | async" [alt]="expandedMedia$().name" />
      }

      <div class="media__images-footer">
        <button
          mat-icon-button
          matTooltip="Previous Image"
          [disabled]="expandedMediaIndex$() === 0"
          (click)="expandedMediaIndex$.set(expandedMediaIndex$() - 1)"
        >
          <fa-icon [icon]="faArrowLeft"></fa-icon>
        </button>
        <span class="media__images-footer__page fs__sm"> {{ expandedMediaIndex$() + 1 }} / {{ data.media.length }} </span>
        <button
          mat-icon-button
          matTooltip="Next Image"
          [disabled]="expandedMediaIndex$() === data.media.length - 1"
          (click)="expandedMediaIndex$.set(expandedMediaIndex$() + 1)"
        >
          <fa-icon [icon]="faArrowRight"></fa-icon>
        </button>
      </div>
    </div>
  } @else {
    <div class="media__images-cloud">
      @for (media of mediaMapped$()[currentPage$()]; track media.id) {
        @if (media.url$ | async; as url) {
          <div class="media__images-image" [class.audio]="media.type === fileType.AudioMp3">
            <span class="media__images-image__type fs__sm">{{ fileTypeTexts[media.type] }}</span>
            @if (media.type === fileType.VideoMp4) {
              <video eiq-media-broken controls>
                <source [src]="url" />
              </video>
            } @else if (media.type === fileType.AudioMp3) {
              <audio controls>
                <source [src]="url" />
              </audio>
            } @else {
              <img eiq-media-broken [src]="url" [alt]="media.name" />
            }
            <div class="media__images-image__action">
              <mat-checkbox color="primary" [checked]="selectedMedia$().includes(media.id)" [labelPosition]="'after'" (change)="onSelect(media.id)">
                <span class="fs__sm checkbox-label">Select</span>
              </mat-checkbox>
              @if (media.type !== fileType.AudioMp3) {
                <button mat-icon-button matTooltip="Expand" (click)="onExpandMedia($index)">
                  <fa-icon [icon]="faUpRightAndDownLeftFromCenter"></fa-icon>
                </button>
              }
            </div>
          </div>
        }
      }

      @if (mediaMapped$().length > 1) {
        <div class="media__images-footer">
          <button mat-icon-button matTooltip="Previous" [disabled]="currentPage$() === 0" (click)="onPreviousPage()">
            <fa-icon [icon]="faArrowLeft"></fa-icon>
          </button>
          <span class="media__images-footer__page fs__sm"> {{ currentPage$() + 1 }} / {{ mediaMapped$().length }} </span>
          <button mat-icon-button matTooltip="Next" [disabled]="currentPage$() === mediaMapped$().length - 1" (click)="onNextPage()">
            <fa-icon [icon]="faArrowRight"></fa-icon>
          </button>
        </div>
      }
    </div>
  }
</div>

<div class="media__images-dialog-actions" mat-dialog-actions>
  <div class="media__images-download">
    <button
      mat-stroked-button
      color="primary"
      class="next-btn"
      [disabled]="selectedMedia$().length === 0 || isDownloadingSelected$()"
      (click)="onDownloadSelected()"
    >
      @if (isDownloadingSelected$()) {
        <div class="eiq-button__loading">
          <mat-spinner diameter="20" color="light"></mat-spinner>
          <span>Downloading...</span>
        </div>
      } @else {
        Download Selected ({{ selectedMedia$().length }})
      }
    </button>
    <button mat-flat-button color="primary" class="next-btn" [disabled]="isDownloadingAll$()" (click)="onDownloadAll()">
      @if (isDownloadingAll$()) {
        <div class="eiq-button__loading">
          <mat-spinner diameter="20" color="light"></mat-spinner>
          <span>Downloading...</span>
        </div>
      } @else {
        Download All
      }
    </button>
  </div>
  <button mat-stroked-button (click)="onCancel()">Close</button>
</div>
